<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <form>
      <md-card class="">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>lock</md-icon>
          </div>
          <h4 class="title">{{ data.label }}</h4>
        </md-card-header>

        <md-card-content>
          <ValidationProvider
            name="currentPassword"
            rules="required|min:3"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>security</md-icon>
              <label>Huidig wachtwoord</label>
              <md-input v-model="currentPassword" type="password"></md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>

          <ValidationProvider
            name="password"
            rules="required|min:8"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>security</md-icon>
              <label>Nieuw wachtwoord</label>
              <md-input v-model="password" type="password"></md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>

          <ValidationProvider
            name="confirmPassword"
            rules="required|confirmed:password"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>security</md-icon>
              <label>Bevestig nieuw wachtwoord</label>
              <md-input v-model="confirmPassword" type="password"></md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </md-card-content>
        <md-card-actions>
          <md-button
            :disabled="!formTouched || requesting"
            native-type="submit"
            @click.native.prevent="validate"
            class="md-success"
          >
            Opslaan
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      requesting: false,
      currentPassword: "",
      password: "",
      confirmPassword: "",
      touched: {
        currentPassword: false,
        password: false,
        confirmPassword: false
      },
      modelValidations: {
        currentPassword: {
          required: true,
          min: 8
        },
        password: {
          required: true,
          min: 8
        },
        confirmPassword: {
          required: true,
          confirmed: "password"
        }
      }
    };
  },
  props: ["data"],
  methods: {
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("‑");
    },
    formatPhone(phoneNumber) {
      if (typeof phoneNumber !== "string") {
        return phoneNumber;
      }

      phoneNumber = phoneNumber.split("-");

      if (phoneNumber.length == 2 && phoneNumber[0].length == 2) {
        phoneNumber[1] =
          phoneNumber[1].substr(0, 2) +
          " " +
          phoneNumber[1].substr(2, 3) +
          " " +
          phoneNumber[1].substr(5, 3);
      } else if (phoneNumber.length == 2 && phoneNumber[0].length == 3) {
        phoneNumber[1] =
          phoneNumber[1].substr(0, 3) +
          " " +
          phoneNumber[1].substr(3, 2) +
          " " +
          phoneNumber[1].substr(5, 2);
      } else if (phoneNumber.length == 2 && phoneNumber[0].length == 4) {
        phoneNumber[1] =
          phoneNumber[1].substr(0, 3) + " " + phoneNumber[1].substr(3, 3);
      }

      return phoneNumber.join("‑");
    },
    convertPhoneToInternational(phoneNumber) {
      if (typeof phoneNumber !== "string") {
        return phoneNumber;
      }

      return "+31" + phoneNumber.substr(1, 10).replace("-", "");
    },
    getFullName(data) {
      return (
        data["first_name"] +
        " " +
        (data["last_name_prefix"] ? data["last_name_prefix"] + " " : "") +
        data["last_name"]
      );
    },
    handleMail(item) {
      window.location = "mailto:" + item.email;
    },
    validate() {
      if (this.password !== this.confirmPassword) {
        this.notifyVue(
          "Nieuwe wachtwoorden komen niet overeen",
          "report_problem",
          "danger",
          0
        );

        return;
      }

      this.requesting = true;
      this.$http
        .post(
          this.$apiBaseUrl + "user/changePassword",
          Object.assign({
            password_current: this.currentPassword,
            password_new: this.password
          })
        )
        .then(
          response => {
            this.password = "";
            this.confirmPassword = "";
            this.currentPassword = "";
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Wachtwoord succesvol gewijzigd",
              "check",
              "success",
              5000
            );

            this.requesting = false;
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens wijzigen wachtwoord",
                "report_problem",
                "danger",
                0
              );
            }

            this.requesting = false;
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    resetTouched() {
      this.touched.currentPassword = false;
      this.touched.password = false;
      this.touched.confirmPassword = false;
    }
  },
  watch: {
    currentPassword() {
      if (!this.requesting) {
        this.touched.currentPassword = true;
      }
    },
    password() {
      if (!this.requesting) {
        this.touched.password = true;
      }
    },
    confirmPassword() {
      if (!this.requesting) {
        this.touched.confirmPassword = true;
      }
    },
    $route(to, from) {
      this.mounted();
    }
  },
  computed: {
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    }
  },
  mounted() {
    setTimeout(this.resetTouched, 100);
  }
};
</script>
<style lang="scss"></style>
